/**
 * @param {AppLibrary} library
 * @param {string} appName
 * @constructor
 */
export let Loader = function (library, appName) {

  /**
   * @type string
   */
  let currentPage = library.getCurrentPage();

  /**
   * @type {string}
   */
  let loadJQuery = '';

  /**
   * @type {{}}
   */
  let getVars = window.location.search.replace('?', '').split('&').reduce(
      (result, part) => {
        let keyVal = part.split('=');
        result[decodeURIComponent(keyVal[0])] = decodeURIComponent(keyVal[1]);
        return result;
      },
      {}
  );

  /**
   * @type {{selectorPicker: null|function(string), appResources: [{url: string, pages: [string]}]}}
   */
  let params = {
    selectorPicker: null, // function will receive current page name and must return true/false - to start or not start SP in that page
    appResources: []
  };

  /**
   * @param {string} min
   * @param {string} recommended
   */
  this.requireJQuery = function (min, recommended = '') {
    recommended = recommended || min;

    // todo: Корректно сравнить версии
    if (typeof jQuery === 'undefined' || parseFloat(jQuery.fn.jquery) < parseFloat(min)) {
      loadJQuery = recommended;
    }
  };

  /**
   * @param {function(string)} callback
   */
  this.enableSelectorPicker = function (callback) {
    params.selectorPicker = callback;
  };

  /**
   * @param {array} url
   * @param {[string]} pages
   */
  this.addResources = function (url, pages = []) {
    if (!Array.isArray(pages)) {
      pages = [pages];
    }
    params.appResources.push({
      url: url,
      pages: pages
    });
  };

  /**
   * @param {function(jQuery, string)} appEntryPoint
   */
  this.run = function (appEntryPoint) {
    if (params.selectorPicker !== null && typeof(getVars.sign) !== 'undefined' && getVars.sign === appName) {
      if(typeof(params.selectorPicker) !== 'function' || params.selectorPicker(currentPage)){
        loadStatic(getVars.script);
      }
      return;
    }

    try {
      if (loadJQuery !== '') {
        loadStatic(
            '//ajax.googleapis.com/ajax/libs/jquery/' + loadJQuery + '/jquery.min.js',
            function () {
              let $ = jQuery.noConflict(true);
              runApp($, appEntryPoint);
            }
        );
      } else {
        runApp(typeof(jQuery) !== 'undefined' ? jQuery : null, appEntryPoint);
      }
    } catch (e) {
      throw new Error(appName + ' app exception: ' + e.message);
    }
  };

  /**
   * @param {jQuery} $
   * @param {function(jQuery, string)} appEntryPoint
   */
  let runApp = function ($, appEntryPoint) {
    loadStatic(
        getResources(currentPage),
        () => {
          library.onLoad(() => {
            // Run App
            appEntryPoint($, currentPage);
          });
        }
    );
  };

  /**
   * @param {string} page
   * @return {[string]}
   */
  let getResources = function (page) {
    let resources = [];
    for (let i = 0; i < params.appResources.length; i++) {
      let resource = params.appResources[i];
      if (!resource.pages.length || resource.pages.indexOf(page) !== -1 || resource.pages.indexOf('all') !== -1) {
        resources.push(resource.url);
      }
    }
    return resources;
  };

  /**
   * @type {{}}
   */
  let __loadStatic_cache = {};

  /**
   * @param {string|[string]} url one or more
   * @param {function()} callback
   * @param {string} type 'js' or 'css'
   */
  let loadStatic = function (url, callback = () => null, type = '') {
    if (Array.isArray(url)) {
      if (!url.length) {
        callback();
      } else {
        let loadedCnt = 0;
        url.forEach(function (u) {
          loadStatic(
              u,
              function () {
                loadedCnt++;
                if (loadedCnt === url.length) {
                  callback();
                }
              },
              type
          );
        });
      }
    } else if (typeof(__loadStatic_cache[url]) !== 'undefined') {
      callback();
    } else {
      if (type !== 'js' && type !== 'css') {
        type = url.toLowerCase().split('?')[0].split('#')[0].split('.').pop();
      }
      if (type !== 'js' && type !== 'css') {
        throw new Error('Undefined type of static file "' + url + '"');
      }
      let tag;
      if (type === 'js') {
        tag = document.createElement('script');
        tag.type = 'text/javascript';
      } else {
        tag = document.createElement('link');
        tag.type = 'text/css';
        tag.rel = 'stylesheet';
      }
      if (tag.readyState) {// If the browser is Internet Explorer.
        tag.onreadystatechange = function () {
          if (tag.readyState === 'loaded' || tag.readyState === 'complete') {
            tag.onreadystatechange = null;
            __loadStatic_cache[url] = 1;
            callback();
          }
        };
      } else { // For any other browser.
        tag.onload = function () {
          __loadStatic_cache[url] = 1;
          callback();
        };
      }
      if (type === 'js') {
        tag.src = url;
      } else {
        tag.href = url;
      }
      document.getElementsByTagName('head')[0].appendChild(tag);
    }
  };
};
